// Central configuration - change API_BASE here for all API calls
const config = {
  API_BASE: 'https://vbscaching.travomint.co/gfsRule/api',
  // API_BASE: 'http://localhost:8081/api',
};

export default config;
